import React, { useState } from 'react';
import { MapPinIcon, ArrowRightIcon, ArrowLeftIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function LoginPage({
  navigateTo
}: {
  navigateTo: (page: string) => void;
}) {
  const {
    t
  } = useLanguage();
  const [step, setStep] = useState(1);
  const [identifier, setIdentifier] = useState('');
  const [otp, setOtp] = useState('');
  const handleGetOtp = (e: React.FormEvent) => {
    e.preventDefault();
    if (identifier) setStep(2);
  };
  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    if (otp) navigateTo('dashboard');
  };
  return <div className="min-h-screen bg-[#F8FAFB] flex flex-col justify-center py-12 sm:px-6 lg:px-8 relative" data-id="element-1588">
      {/* Back to Home */}
      <button onClick={() => navigateTo('home')} className="absolute top-6 left-6 flex items-center gap-2 text-[#006A4E] hover:text-[#004D3A] font-medium text-sm transition-colors" data-id="element-1589">
        <ArrowLeftIcon className="w-4 h-4" data-id="element-1590" />
        হোমে ফিরে যান
      </button>

      <div className="sm:mx-auto sm:w-full sm:max-w-md" data-id="element-1591">
        <div className="flex justify-center" data-id="element-1592">
          <div className="w-16 h-16 bg-[#006A4E] rounded-2xl flex items-center justify-center shadow-lg" data-id="element-1593">
            <MapPinIcon className="w-8 h-8 text-white" data-id="element-1594" />
          </div>
        </div>
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900" data-id="element-1595">
          {t('appTitleShort')}
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600" data-id="element-1596">
          Government of the People's Republic of Bangladesh
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md" data-id="element-1597">
        <div className="bg-white py-8 px-4 shadow-xl shadow-gray-200/50 sm:rounded-xl sm:px-10 border border-gray-100" data-id="element-1598">
          {step === 1 ? <form className="space-y-6" onSubmit={handleGetOtp} data-id="element-1599">
              <div data-id="element-1600">
                <label htmlFor="identifier" className="block text-sm font-medium text-gray-700" data-id="element-1601">
                  {t('enterMobileNID')}
                </label>
                <div className="mt-2" data-id="element-1602">
                  <input id="identifier" name="identifier" type="text" required value={identifier} onChange={e => setIdentifier(e.target.value)} className="appearance-none block w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#006A4E] focus:border-[#006A4E] sm:text-sm" placeholder="e.g. 01712345678 or 1987654321098" data-id="element-1603" />
                </div>
              </div>

              <div data-id="element-1604">
                <button type="submit" className="w-full flex justify-center items-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-[#006A4E] hover:bg-[#004D3A] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#006A4E] transition-colors" data-id="element-1605">
                  {t('getOTP')}
                  <ArrowRightIcon className="ml-2 w-4 h-4" data-id="element-1606" />
                </button>
              </div>
            </form> : <form className="space-y-6" onSubmit={handleLogin} data-id="element-1607">
              <div data-id="element-1608">
                <label htmlFor="otp" className="block text-sm font-medium text-gray-700" data-id="element-1609">
                  {t('enterOTP')}
                </label>
                <p className="text-xs text-gray-500 mt-1 mb-3" data-id="element-1610">
                  OTP sent to {identifier}
                </p>
                <div className="mt-1 flex justify-between space-x-2" data-id="element-1611">
                  {[1, 2, 3, 4, 5, 6].map(i => <input key={i} type="text" maxLength={1} className="w-12 h-14 text-center text-xl font-bold border border-gray-300 rounded-lg focus:ring-[#006A4E] focus:border-[#006A4E]" onChange={e => {
                if (e.target.value && i < 6) {
                  const next = e.target.nextElementSibling as HTMLInputElement;
                  if (next) next.focus();
                }
                setOtp(prev => prev + e.target.value);
              }} data-id="element-1612" />)}
                </div>
              </div>

              <div data-id="element-1613">
                <button type="submit" className="w-full flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-[#006A4E] hover:bg-[#004D3A] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#006A4E] transition-colors" data-id="element-1614">
                  {t('verifyLogin')}
                </button>
              </div>

              <div className="text-center" data-id="element-1615">
                <button type="button" onClick={() => setStep(1)} className="text-sm text-[#006A4E] hover:underline font-medium" data-id="element-1616">
                  Change Mobile/NID
                </button>
              </div>
            </form>}
        </div>
      </div>
    </div>;
}